/**
 * AssetLogTypeService
 * Service for AssetLogType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetLogType CRUD operations */
export class AssetLogTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetLogTypeService.DEFAULT_SERVICE_PATH,
            basePath: AssetLogTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetLogTypeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetLogTypeService.BASE_PATH = 'api/asset-log-types';
//# sourceMappingURL=AssetLogTypeService.js.map